import React, { useMemo } from 'react'
import styled from 'styled-components'

import { ORG_ROLES } from '@constants'
import OrgRole from '@data/model/NewModals/OrgRole'
import { Spacings, Text } from '@styles'
import { DrawerBodyWrapper } from '@base'
import { Button } from '@baseV2'

import { InputsWrapper, NoDataText } from '../styles'

const RoleRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: ${Spacings.SPACING_2B};
	padding: ${Spacings.SPACING_3B} ${Spacings.SPACING_4B};
	border: 1px solid ${({ theme }) => theme.colors.border.default};
	border-radius: ${({ theme }) => theme.radius.md};
	background: ${({ theme }) => theme.colors.surface.card};
`

const RoleName = styled.span`
	font-size: ${Text.BASE_SMALL};
	font-weight: ${Text.BOLD_500};
	color: ${({ theme }) => theme.colors.text.primary};
`

const AddOrgRole = ({ existingRoles = [], requestRolesHandler, requestRole }) => {
	const availableRoles = useMemo(
		() =>
			Object.values(ORG_ROLES)
				.map((role) =>
					existingRoles.findIndex((r) => r.platform === role.platform && r.role === role.role && r.approved) === -1 ? role : null
				)
				.filter(Boolean)
				.map((r) => new OrgRole(r).toJS()),
		[existingRoles]
	)

	const onAdd = (role) => {
		if (requestRole) {
			role.requested = true
		} else {
			role.approved = true
		}
		requestRolesHandler?.([...existingRoles, role], true)
	}

	return (
		<DrawerBodyWrapper>
			<InputsWrapper>
				{availableRoles?.length ? (
					availableRoles.map((role) => (
						<RoleRow key={role.platform + role.role}>
							<RoleName>
								{role.platform} {role.role}
							</RoleName>
							<Button size='small' color='primary' onClick={() => onAdd(role)}>
								{requestRole ? 'Request Role' : 'Add Role'}
							</Button>
						</RoleRow>
					))
				) : (
					<NoDataText>{`No more roles to be ${requestRole ? 'requested' : 'added'}`}</NoDataText>
				)}
			</InputsWrapper>
		</DrawerBodyWrapper>
	)
}

export default AddOrgRole
